import loadable from '@loadable/component';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import React from 'react';
import tagProducts from '../queries/tagProducts';
import AudioPlayers from './AudioPlayer';
import ConservationBanner from './ConservationBanner';
import If from './If';
import ProductAccordion from './ProductAccordion';
import ProductDesc from './ProductDesc';
import ProductGallery from './ProductGallery';
import QuoteCarousel from './QuoteCarousel';
import SectionHeader from './SectionHeader';
import SimpleCollection from './SimpleCollection';

const VideoGallery = loadable(() => import('./VideoGallery'));

export default function ProductPage(props: any) {
  const tags = props.tags.filter(
    (t: string) => t !== 'New' && !t.endsWith('hp') && t != 'BatConservation'
  );

  const alsoLike = tagProducts(
    tags,
    ['Legacy'],
    tags,
    props.handle,
    3,
    0,
    false
  );

  const [variant, setVariantState] = React.useState(0);
  const [index, setIndexState] = React.useState(0);
  const setIndex = (i: number) => {
    setIndexState(i);
  };
  const setVariant = (v: number) => {
    setVariantState(v);
    setIndex(v);
  };
  return (
    <>
      <Stack
        direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Stack width='50%'>
          <ProductGallery
            images={props.images}
            index={index}
            setIndex={setIndex}
          ></ProductGallery>
        </Stack>
        <Divider
          orientation='vertical'
          style={{ width: '0.001%' }}
          flexItem
          color='black'
          role='presentation'
        />
        <Box display='flex' sx={{ width: { sm: '55%', md: '60%' } }}>
          <Stack sx={{ justifyContent: 'center' }} mr={4}>
            <ProductDesc
              variant={variant}
              setVariant={setVariant}
              {...props}
            ></ProductDesc>
          </Stack>
        </Box>
      </Stack>
      <If value={props.videos}>
        <VideoGallery {...props} />
      </If>
      <If value={props.sounds}>
        <Divider
          sx={{ mt: 1 }}
          flexItem
          color='black'
          role='presentation'
        ></Divider>
        <AudioPlayers files={props.sounds}></AudioPlayers>
      </If>
      <ProductAccordion {...props}></ProductAccordion>
      <Divider
        sx={{ mt: 1 }}
        flexItem
        color='black'
        role='presentation'
      ></Divider>

      <If value={alsoLike.length !== 0 && !tags.includes('Legacy')}>
        <SectionHeader
          title='you might also like'
          buttonText='View All'
          href='/collections/all'
        ></SectionHeader>
        <SimpleCollection products={alsoLike} />
      </If>
      <If value={props.quotes}>
        <QuoteCarousel items={props.quotes}></QuoteCarousel>
      </If>

      <ConservationBanner
        conservation={props.conservation}
      ></ConservationBanner>
    </>
  );
}
